import { usePlotHover } from 'components/sections/admin-portal/machines/dialogs/pitch-performance/plots/plot-hover';
import useAnalyticsStore from 'components/sections/analytics/store/use-analytics-store';
import { IPointer } from 'interfaces/session-recap/i-pointer';
import { useCallback, useRef, useState } from 'react';

/** selection stays in the analytics store; hover is the admin plot hover */
export const useRecapHover = () => {
  const { hoveredItemKey, hoverHandlers } = usePlotHover();
  const selectedHitID = useAnalyticsStore((s) => s.selectedHitID);
  const handlersRef = useRef(hoverHandlers);
  handlersRef.current = hoverHandlers;

  const [pointer, setPointer] = useState<IPointer | null>(null);
  /** pitch this chart last entered, so a late leave cannot clear its tooltip */
  const ownerID = useRef<string | null>(null);

  const onEnter = useCallback((id: string, p: IPointer) => {
    ownerID.current = id;
    setPointer(p);
    handlersRef.current(id).onMouseEnter?.();
  }, []);

  const onLeave = useCallback((id: string) => {
    handlersRef.current(id).onMouseLeave?.();

    if (ownerID.current !== id) {
      return;
    }

    ownerID.current = null;
    setPointer(null);
  }, []);

  const onSelect = useCallback((id: string) => {
    useAnalyticsStore.setState({ selectedHitID: id });
  }, []);

  const clear = useCallback(() => {
    const id = ownerID.current;

    if (id) {
      onLeave(id);
    }
  }, [onLeave]);

  return {
    hoveredHitID: hoveredItemKey ?? null,
    selectedHitID,
    pointer,
    onEnter,
    onLeave,
    onSelect,
    clear,
  };
};
